/* 🤖 this file was generated by script */
export const wiconCornerUpLeft = {
  name: 'corner_up_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14L4 9m0 0l5-5M4 9h6.4c3.36 0 5.04 0 6.32.65a6 6 0 012.63 2.63c.65 1.28.65 2.96.65 6.32V20"/></svg>`,
};
